import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InternalRedirectGuardService {
  constructor(public router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const queryParams = route.queryParams;

    const sanitizedParams = new URLSearchParams();

    for (const key of Object.keys(queryParams)) {
      const value = queryParams[key];

      if (typeof value === 'string') {
        sanitizedParams.set(key, encodeURIComponent(value));
      } else if (Array.isArray(value)) {
        value.forEach((item) =>
          sanitizedParams.append(key, encodeURIComponent(item))
        );
      }
    }

    const paramsString = sanitizedParams.toString();
    const ref = paramsString ? `fiserv/login?${paramsString}` : 'fiserv/login';

    window.location.href = ref;

    return false;
  }
}
